module.exports = __webpack_public_path__ + "static/strafe0-12c7bb1ebfc76869bc79fdbd55f5431a.mp4";